import type {} from 'koa-body';

import workflows from './workflows';
import stages from './stages';
import assignees from './assignees';

export default {
  workflows,
  stages,
  assignees,
};
